(function() {
	'use strict';

	angular
		.module('as.groups')
		.controller('groupAboutCtrl',groupAboutCtrl);

	groupAboutCtrl.$inject = ['$scope','groupDetail'];
	function groupAboutCtrl($scope,groupDetail) {
		//variables
		
		//function bindings
		
		activate();

		function activate() {
			if(groupDetail.success == 1 && groupDetail.data){
				$scope.chapter = groupDetail.data;
				if(groupDetail.data.attributes && groupDetail.data.attributes.about && groupDetail.data.attributes.isAboutHtml!='1') {
					$scope.about = groupDetail.data.attributes.about.split("\n").join("<br />");
				}
				else if(groupDetail.data.attributes && groupDetail.data.attributes.about && groupDetail.data.attributes.isAboutHtml=='1') {
					$scope.about = groupDetail.data.attributes.about;
				}
			}
		}

	}
})();